// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ej9z","toggleWrap":"styles_toggleWrap__yb7y8","content":"styles_content__8yCFL","selectAreaCode":"styles_selectAreaCode__2BYIr"};